import { SelectedFileCard } from "@/components/file-drop-zone";
import {
  PeriodChip,
  TypeChip,
  YearChip,
} from "@/components/common/report-chip";
import { ParsedDsdMeta } from "@/components/modals/upload-dsd/parse-dsd-filename";

interface NewFileCardProps {
  filename: string;
  meta: ParsedDsdMeta;
  onRemove: () => void;
}

// ============================================
// NewFileCard
// 업로드 영역 안, 새 버전으로 올릴 DSD 파일 카드. 표현만 담당.
// 카드 틀(회색 카드·아이콘 칸·제거 버튼)은 SelectedFileCard 가 맡고, 여기서는 뱃지 줄만 채운다.
// ============================================

export const NewFileCard = ({ filename, meta, onRemove }: NewFileCardProps) => (
  <SelectedFileCard format="dsd" onRemove={onRemove}>
    <div className="flex items-center gap-1">
      {meta.type && <TypeChip type={meta.type} size="large" />}
      {meta.year && <YearChip year={meta.year} size="large" />}
      {meta.period && <PeriodChip period={meta.period} size="large" />}
    </div>
    <p className="label-1-normal-regular truncate text-label-normal">
      {filename}
    </p>
  </SelectedFileCard>
);
